
import React from "react";
import { UseFormReturn } from "react-hook-form";
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useParcels } from "@/services/parcels";
import { ActivityFormValues } from "../schema/activitySchema";

interface ActivityParcelSelectProps {
  form: UseFormReturn<ActivityFormValues>;
}

export const ActivityParcelSelect: React.FC<ActivityParcelSelectProps> = ({ form }) => {
  const { data: parcels, isLoading, error } = useParcels();

  if (isLoading) {
    return (
      <FormItem>
        <FormLabel>Parcelle associée</FormLabel>
        <Select disabled>
          <FormControl>
            <SelectTrigger>
              <SelectValue placeholder="Chargement des parcelles..." />
            </SelectTrigger>
          </FormControl>
        </Select>
      </FormItem>
    );
  }

  if (error || !parcels) {
    console.error("Erreur lors du chargement des parcelles:", error);
    return (
      <FormItem>
        <FormLabel>Parcelle associée</FormLabel>
        <Select disabled>
          <FormControl>
            <SelectTrigger>
              <SelectValue placeholder="Erreur de chargement" />
            </SelectTrigger>
          </FormControl>
        </Select>
      </FormItem>
    );
  }

  return (
    <FormField
      control={form.control}
      name="parcel_id"
      render={({ field }) => (
        <FormItem>
          <FormLabel>Parcelle associée</FormLabel>
          <Select 
            onValueChange={field.onChange} 
            defaultValue={field.value || undefined}
          >
            <FormControl>
              <SelectTrigger>
                <SelectValue placeholder="Sélectionner une parcelle (optionnel)" />
              </SelectTrigger>
            </FormControl>
            <SelectContent>
              <SelectItem value="none">Aucune parcelle</SelectItem>
              {parcels.map((parcel) => (
                <SelectItem key={parcel.id} value={parcel.id}>
                  {parcel.name}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
